import { Leaf, ChildrenAnalyzer } from "@contember/react-multipass-rendering";
import { ContentOutlet } from "./ContentOutlet.js";
class BoxedContentOutletProps {
  constructor(value) {
    this.value = value;
  }
}
class BoxedCatchAllJSX {
  constructor(value) {
    this.value = value;
  }
}
const outletLeaf = new Leaf((node) => new BoxedContentOutletProps(node.props), ContentOutlet);
const catchAllJSXLeaf = new Leaf((node) => new BoxedCatchAllJSX(node));
const editorTemplateAnalyzer = new ChildrenAnalyzer([
  /*textFieldLeaf, */
  outletLeaf,
  catchAllJSXLeaf
]);
export {
  BoxedCatchAllJSX,
  BoxedContentOutletProps,
  editorTemplateAnalyzer
};
//# sourceMappingURL=editorTemplateAnalyzer.js.map
